export default {
    list: {
        title: 'Události',
        empty: 'Žádné události',
        cols: {
            name: 'Jméno',
            startAt: 'Začátek',
            endAt: 'Konec',
            status: 'Stav'
        }
    },
    status: {
        upcoming: 'Nadcházející',
        ongoing: 'Probíhá',
        past: 'Proběhlo',
        unknown: 'Neurčeno'
    },
    filter: {
        search: 'Hledat',
        status: 'Stav',
        from: 'Od',
        to: 'Do',
        statusOptions: {
            all: 'Vše',
            upcoming: 'Nadcházející',
            ongoing: 'Probíhá',
            past: 'Proběhlo'
        }
    },
    actions: {
        newEvent: '+ Nová událost'
    },
    form: {
        name: 'Jméno',
        startAt: 'Začátek',
        endAt: 'Konec',
        errors: {
            endBeforeStart: 'Konec musí být po začátku'
        },
        warnings: {
            startInPast: 'Začátek je v minulosti'
        }
    },
    bzucoSynced: {
        tooltip: 'Synchronizováno z externího systému, nelze smazat',
        badge: 'Synced'
    },
    confirm: {
        deleteTitle: 'Smazat událost?',
        deleteBody: 'Opravdu chcete smazat událost „{name}"?',
        bulkDeleteTitle: 'Smazat vybrané události?',
        bulkDeleteBody: 'Opravdu chcete smazat {n} událostí?',
        unsavedChanges: 'Máte neuložené změny. Opravdu zavřít?'
    },
    bulk: {
        selected: '{n} vybráno',
        deleteSelected: 'Smazat vybrané',
        deleteResult: '{ok} smazáno, {failed} selhalo'
    },
    toast: {
        saved: 'Událost uložena',
        deleted: 'Událost smazána'
    }
}
